var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('b-container',{staticClass:"py-5 main-container",attrs:{"fluid":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }